<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.cancelled_bet_list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker(@update="submit")
                //- DateRangePicker(:value="dateRange")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-form-checkbox(
                  ref="working_date"
                  v-model="working_date"
                ) {{ this.$t("message.search_with_working_date") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="betList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(working_date)="row")
                    span {{ (row.item.working_date) ? $moment(row.item.working_date).format("YYYY-MM-DD") : $moment(row.item.bet_time).format("YYYY-MM-DD") }}
                    br
                    span #[b {{ row.item.bet_id }}]
                  template(v-slot:cell(downline_id)="row")
                    span {{ row.item.downline_id.toUpperCase() }}
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    template(v-if="row.item.bet_type == 'PARLAY'")
                      span(v-if="row.item.bet_type_share == 'PARLAYMMO'") #[b {{ $t("ui.mmo_parlay") }}]
                      span(v-else) #[b {{ $t("ui.mix_parlay") }}]
                      template(v-if="row.item.odds_display_bet")
                        br
                        span.mr-1 {{ row.item.bet_member }} @
                        span {{ row.item.odds_display_bet }}
                    template(v-else)
                      div
                        span.badge.bg-blue-darker.mr-1 {{ row.item.league_id }}
                        span {{ getName(row.item.league_id, 0) }}
                      div(v-if="row.item.home_team_name != null")
                        span.badge.bg-orange-darker.mr-1 {{ row.item.match_id }}
                        span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                        span.mr-1 vs
                        span(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                      div
                        span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                        span.ml-1(v-if="isLiveMarket(row.item)") [{{ row.item.home_running_score }} - {{ row.item.away_running_score }}]
                  template(v-slot:cell(detail)="row")
                    template(v-if="row.item.bet_type == 'PARLAY'")
                      span @ {{ row.item.odds_display }}
                      template(v-if="row.item.bet_status != 'Rejected'")
                        br
                        span.label.bg-black {{ $t("ui.details") }}
                        template(v-if="row.item.bet_type_share == 'PARLAYMMO'")
                          i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetailMMO(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                        template(v-else)
                          i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                    template(v-else)
                      div.mb-1
                        span.label.bg-black #[b {{ getBetType(row.item) }}]
                      div
                        span(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item, getName(row.item.match_id, 1), getName(row.item.match_id, 2)) }}
                      div
                        span {{ row.item.agent_pt }} x {{ row.item.bet_member }}
                        br
                        span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                        span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="parlayList" :fields="vDfields")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(working_date)="row")
                        span {{ $moment(row.item.working_date).format("YYYY-MM-DD HH:mm:ss") }}
                      template(v-slot:cell(league_name)="row")
                        span {{ getParlayName(row.item.league_id, 0) }}
                      template(v-slot:cell(home_team_name)="row")
                        span(:class="row.item.home_giving == 1 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 1) }}
                      template(v-slot:cell(away_team_name)="row")
                        span(:class="row.item.home_giving == 0 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 2) }}
                      template(v-slot:cell(full_half)="row")
                        span {{ (row.item.full_half == 1) ? $t("ui.full_time") : $t("ui.half_time") }}
                      template(v-slot:cell(running_score)="row")
                        span {{ row.item.running_score ? row.item.running_score : '-' }}
                      template(v-slot:cell(status)="row")
                        template(v-if="isMMO")
                          span {{ $helpers.showWinStatusMMO(row.item) }}
                        template(v-else)
                          span {{ $helpers.showWinStatus(row.item) }}
                  template(v-slot:cell(bet_member)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_member)") #[b {{ row.item.bet_member | currency }} ]
                  template(v-slot:cell(bet_status)="row")
                    span {{ betStatus(row.item) }}
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";

export default {
  components: {
    SubmitButton,
    DateRangePicker,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      working_date: true,
      betList: [],
      parlayList: [],
      isMMO: false,
      filter: null,
      sortBy: "bet_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      match: [],
      league: [],
      matchParlay: [],
      leagueParlay: []
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "working_date",
          label: this.$t("ui.date_time"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "downline_id",
          label: this.$t("ui.downline_id"),
          class: "align-middle text-left " + this.show(),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "bet_member",
          label: this.$t("ui.amount"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "12%"
          }
        },
        {
          key: "bet_status",
          label: this.$t("ui.status"),
          sortable: true,
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "12%"
          }
        }
      ]
    },
    vDfields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "working_date",
          label: this.$t("ui.date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_half",
          label: this.$t("ui.match_time"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "payout_odds",
          label: this.$t("ui.payout"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_score",
          label: this.$t("ui.home_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_score",
          label: this.$t("ui.away_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "running_score",
          label: this.$t("ui.running_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    isLiveMarket: function(item) {
      return item.market_type == 3 && (item.bet_type == 'HDP' || item.bet_type == 'HDPH' || item.bet_type == 'OU' || item.bet_type =='OUH')
    },
    getBetType(item) {
      let type = item.bet_type
      let share = item.bet_type_share

      if(type == 'HDP' && share == 'HDPMMO') {
        return this.$tc("m.BT_HDPMMO")
      }

      if(type == 'OU' && share == 'HDPMMO') {
        return this.$tc("m.BT_OUMMO")
      }

      return this.$tc("m.BT_" + type, 2)
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getParlayName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.leagueParlay.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.matchParlay.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    betStatus: function(item) {
      let code = item.bet_status_code
      let status = ""
      if(item.bet_status == "Rejected") {
        switch(code) {
          case 1:
            status = this.$t("ui.reject")
            break
          case 2:
            status = this.$t("ui.void")
            break
        }
      } else {
        status = this.$t("ui.refund")
      }
      return status
    },
    show: function() {
      return this.$store.getters.accountType > 2 ? '' : 'd-none'
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_by_working_date = (this.working_date) ? 1 : 0
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getCancelledBetlist", { start_date, end_date, search_by_working_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            // console.log("response", response)
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.match = response.names.match
                this.league = response.names.league
                this.totalRows = response.data.length > 0 ? this.betList[0]["totalrows"] : 0
              } else {
                this.betList = []
                this.match = []
                this.league = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.match = []
            this.league = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    getParlayDetail: function(item) {
      this.isMMO = false
      this.parlayList = []
      this.matchParlay = []
      this.leagueParlay = []
      if(item._showDetails) {
        this.betList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      let bet_id = item.bet_id
      this.$store
        .dispatch("user/getParlayDetail", { bet_id })
        .then(response => {
          // this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            // this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          // this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getParlayDetailMMO: function(item) {
      this.isMMO = true
      this.parlayList = []
      this.matchParlay = []
      this.leagueParlay = []
      if(item._showDetails) {
        this.betList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      let bet_id = item.bet_id
      this.$store
        .dispatch("user/getParlayDetailMMO", { bet_id })
        .then(response => {
          // this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            // this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          // this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  .custom-checkbox {
    width: 100% !important;
  }
</style>